import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Lock } from "lucide-react";

export default function PublicProfile() {
  const { username } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    axios.get(`${API}/public/${username}`)
      .then(({ data }) => setData(data))
      .catch((e) => setError(e.response?.status === 403 ? "private" : "notfound"));
  }, [username]);

  if (error) return (
    <div className="min-h-screen bg-ink grain flex flex-col items-center justify-center text-center p-6">
      <Logo light />
      <Lock className="text-slate-500 mt-8 mb-3" size={40} />
      <h1 className="font-head font-bold text-2xl text-white">{error === "private" ? "This profile is private" : "Player not found"}</h1>
      <Link to="/" className="text-brand mt-4 font-semibold">Go to CrickTrack →</Link>
    </div>
  );

  if (!data) return <div className="min-h-screen bg-ink flex items-center justify-center"><div className="skeleton h-96 w-80 rounded-2xl" /></div>;

  return (
    <div className="min-h-screen bg-ink grain flex items-center justify-center p-4">
      <div className="w-full max-w-md" data-testid="public-sports-card">
        <div className="rounded-3xl overflow-hidden shadow-2xl border border-white/10" style={{ background: "linear-gradient(160deg,#0B0F17,#031529)" }}>
          <div className="bg-brand p-5 flex items-center justify-between"><Logo light /><span className="text-white/80 text-xs font-bold uppercase tracking-widest">Player Card</span></div>
          <div className="p-6 text-white">
            <div className="flex items-center gap-4">
              <div className="w-20 h-20 rounded-2xl bg-white/10 overflow-hidden flex items-center justify-center font-head font-black text-3xl">{data.photo_url ? <img src={data.photo_url} alt="" className="w-full h-full object-cover" /> : data.name[0]}</div>
              <div>
                <h1 className="font-head font-black text-3xl uppercase leading-none">{data.name}</h1>
                <p className="text-slate-300 text-sm mt-1">{data.role_type} · {data.batting_hand}</p>
                {data.clubs?.length > 0 && <p className="text-brand text-xs font-semibold mt-1">{data.clubs.join(" · ")}</p>}
              </div>
            </div>
            {data.bio && <p className="text-slate-300 text-sm mt-4">{data.bio}</p>}

            {data.batting && (
              <div className="mt-6"><div className="text-[10px] uppercase tracking-widest text-red-400 font-bold mb-2">Batting</div>
                <div className="grid grid-cols-4 gap-2">
                  <CardStat l="Runs" v={data.batting.runs} /><CardStat l="Avg" v={data.batting.average ?? "-"} /><CardStat l="SR" v={data.batting.strike_rate ?? "-"} /><CardStat l="HS" v={data.batting.highest_score} />
                </div>
              </div>
            )}
            {data.bowling && (
              <div className="mt-4"><div className="text-[10px] uppercase tracking-widest text-blue-400 font-bold mb-2">Bowling</div>
                <div className="grid grid-cols-4 gap-2">
                  <CardStat l="Wkts" v={data.bowling.wickets} /><CardStat l="Econ" v={data.bowling.economy ?? "-"} /><CardStat l="Best" v={data.bowling.best_figures ?? "-"} /><CardStat l="Overs" v={data.bowling.overs} />
                </div>
              </div>
            )}
          </div>
          <div className="bg-white/5 px-6 py-3 text-center text-slate-400 text-xs">Powered by CrickTrack · @{data.username}</div>
        </div>
        <div className="text-center mt-4"><Link to="/" className="text-slate-500 text-sm hover:text-white">Create your own card →</Link></div>
      </div>
    </div>
  );
}
function CardStat({ l, v }) { return <div className="bg-white/10 rounded-lg p-2 text-center"><div className="stat-num text-xl tabular">{v}</div><div className="text-[9px] uppercase tracking-widest text-slate-400">{l}</div></div>; }
